"use client";

import { Suspense } from "react";
import { PricingSection } from "@/components/ui/pricing-section";
import { defaultTiers, comparisonTools } from "@/components/pricing-tiers";

function PricingSectionDemo() {
  return (
    <Suspense fallback={<PricingSectionSkeleton />}>
      <PricingSection
        tiers={defaultTiers}
        comparison={comparisonTools}
        showAddOns={false}
      />
    </Suspense>
  );
}

function PricingSectionSkeleton() {
  return (
    <div className="w-full py-12 flex justify-center">
      <div className="animate-pulse flex flex-col items-center gap-4">
        <div className="h-8 w-48 bg-muted rounded" />
        <div className="flex gap-4">
          <div className="h-64 w-72 bg-muted rounded-xl" />
          <div className="h-64 w-72 bg-muted rounded-xl" />
        </div>
      </div>
    </div>
  );
}

export { PricingSectionDemo };
